import React from "react";

const Comment = ({ size = 20, color = "#B8B8BC", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size * 0.9}
    fill="none"
    {...props}
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M10 2C5.468 2 2 5.241 2 9c0 1.352.438 2.619 1.209 3.7a1 1 0 0 1 .122.931l-.763 2.036 2.98-.597a1 1 0 0 1 .628.079A8.862 8.862 0 0 0 10 16c4.532 0 8-3.242 8-7 0-3.759-3.468-7-8-7ZM0 9c0-5.078 4.591-9 10-9s10 3.922 10 9c0 5.078-4.591 9-10 9-1.565 0-3.051-.324-4.377-.905l-4.427.886a1 1 0 0 1-1.132-1.332l1.215-3.24A8.283 8.283 0 0 1 0 9Z"
      clipRule="evenodd"
    />
  </svg>
);

export default Comment;
